import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MaterialFormComponent } from '../materail-form/material-form.component';
import { MaterialFormSettingsModel } from '../../../core/models/material/material-form-settings.model';
import { TextKeys } from '../../../core/i18n/text-keys';
import { ToastService } from '../../../core/services/toast-service';
import { TranslateService } from '@ngx-translate/core';
import { SessionQuery } from '../../../core/state-mangement/session/session.query';
import { MaterialItemsService } from '../../../core/state-mangement/entities/material-items/material-items.service';
import { MaterialListItemModel } from '../../../core/models/material/material-list-item.model';
import { Location } from '@angular/common';
import { OrderListItemModel } from '../../../core/models/order/order-list-item.model';
import { combineLatest, map, Observable, Subscription } from 'rxjs';
import { MaterialCatalogueItemsQuery } from '../../../core/state-mangement/entities/material-catalogue-items/material-catalogue-items.query';
import { MaterialCatalogueItemsService } from '../../../core/state-mangement/entities/material-catalogue-items/material-catalogue-items.service';
import { OrderItemsQuery } from '../../../core/state-mangement/entities/order-items/order-items.query';
import { LocalStateKeys } from '../../../core/state-mangement/local-state-keys';
import { OrderItemsStoreService } from '../../../core/state-mangement/order-items-store-service';
import { StoreInfoParams } from '../../../core/models/store-info-params';
import { Router } from '@angular/router';
import { MaterialModel } from '../../../core/models/material/material-model';
import { PersonalApiModel } from '../../../core/models/personal/person-api.model';
import { MaterialItemsQuery } from '../../../core/state-mangement/entities/material-items/material-items.query';
import { OrderModel } from 'src/app/core/models/client-models';

@Component({
  selector: 'app-material-new',
  templateUrl: './material-new.component.html',
  styleUrls: ['./material-new.component.scss'],
})
export class MaterialNewComponent implements OnInit, OnDestroy {
  @ViewChild('formElement') formElement: MaterialFormComponent;
  @Input() orderStoreKey: LocalStateKeys;

  formSettings = {
    name: true,
    quantity: true,
    price: true,
    date: true,
    // eslint-disable-next-line id-blacklist
    number: true,
    note: true,
    description: true,
    total: true,
    unit: true,
  } as MaterialFormSettingsModel;

  isLoading$: Observable<boolean>;
  defaultValues = {
    date: new Date(),
  } as MaterialListItemModel;

  texts = TextKeys;

  currentOrder: OrderListItemModel;
  currentOrder$: Observable<OrderListItemModel>;
  materialTitle$: Observable<string>;
  private subscriptions = new Subscription();

  private orderItemsQuery: OrderItemsQuery;

  constructor(
    private toastService: ToastService,
    private translateService: TranslateService,
    private sessionQuery: SessionQuery,
    private orderItemsStoreService: OrderItemsStoreService,
    private materialItemsService: MaterialItemsService,
    private materialItemsQuery: MaterialItemsQuery,
    private materialCatalogueItemsQuery: MaterialCatalogueItemsQuery,
    private materialCatalogueItemsService: MaterialCatalogueItemsService,
    private router: Router,
    private location: Location
  ) {}

  ngOnInit() {
    const value = this.router.getCurrentNavigation().extras
      .state as StoreInfoParams;
    if (!value) {
      this.location.back();
    }
    this.orderStoreKey = value.orderStoreKey;
    this.orderItemsQuery = this.orderItemsStoreService.getOrCreateStore(
      this.orderStoreKey
    ).query;

    this.currentOrder = this.orderItemsQuery.getActive();
    this.currentOrder$ = this.orderItemsQuery.selectActive();
    this.materialTitle$ = this.getNewMaterialTitle();
    if (!this.currentOrder) {
      this.location.back();
    }
    this.subscriptions.add(
      this.materialCatalogueItemsQuery.selectActive().subscribe((material) => {
        if (material?.materialCatalogueID) {
          setTimeout(() => this?.formElement?.setValues(material), 0);
        }
      })
    );
    this.isLoading$ = this.materialItemsQuery.selectLoading();
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
    this.materialCatalogueItemsService.clearCache();
  }

  getTranslatedTitle(): Observable<string> {
    return this.translateService.get(TextKeys.material.titleNew);
  }

  getNewMaterialTitle(): Observable<string> {
    return combineLatest({
      translatedTitle: this.getTranslatedTitle(),
      order: this.currentOrder$,
    }).pipe(
      map(({ translatedTitle, order }) => {
        const formattedString = order?.orderNumber + ' - ' + order?.orderName;
        return `${translatedTitle}: ${formattedString}`;
      })
    );
  }

  onCancel(event) {
    event.stopImmediatePropagation();
    this.location.back();
  }

  onSave(event) {
    event.stopImmediatePropagation();
    this.formElement.markAllTouched();
    if (!this.formElement.allRequiredFiled()) {
      this.toastService.presentErrorToast({
        message: this.translateService.instant(
          TextKeys.timeEntryForm.allFields
        ),
      });
      return;
    }

    const newMaterial = {
      description: this.formElement.Name.value,
      description2: this.formElement.Description.value,
      quantity: this.formElement.Quantity.value,
      unit: this.formElement.Unit.value,
      price: this.formElement.Price.value,
      // eslint-disable-next-line id-blacklist
      number: this.formElement.MaterialNumber.getValue(),
      note: this.formElement.Note.value,
      date: new Date(this.formElement.Date.value),
      person: {
        id: this.sessionQuery.getValue()?.user?.id,
      } as PersonalApiModel,
      order: { id: this.orderItemsQuery.getActive().orderID } as OrderModel,
    } as MaterialModel;

    console.log(newMaterial);

    this.materialItemsService.saveNewMaterial(newMaterial).subscribe({
      next: (data) => {
        if (data.successful) {
          this.formElement.clearForm();
          this.toastService.presentInfoToast({ message: data.message });
          this.location.back(); // ← nur das, Rest macht die Liste selbst
        }
      },
      error: (error) => {
        console.log(error);
        if (error.error?.message) {
          this.toastService.presentErrorToast({ message: error?.error });
        }
      },
    });
  }
}
